<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex">
				<div class="border">
					<div class="merchant">
						<div style="width: 100px;">商户编号：</div>
						<div>{{information?.merchantNo}}</div>
					</div>
					<div class="merchant">
						<div style="width: 100px;">ApiKey：</div>
						<div>{{ApiKey?information.apiKey:'******'}}</div>
						<div class="copy" v-if="ApiKey" @click="copyText">复制</div>
					</div>
					<div class="merchant">
						<div style="width: 100px;">3DescKey：</div>
						<div>{{ApiKey?information.descKey:'******'}}</div>
						<div class="copy" v-if="ApiKey" @click="copyText1">复制</div>
					</div>
				</div>
				<div class="flex" style="margin-top: 20px; margin-left: 30px;">
					<!-- <el-button type="primary">企业认证</el-button> -->
					<el-button type="success" @click="clickView">{{!ApiKey?'查看密钥':'隐藏密钥'}}</el-button>
					<!-- <el-button type="danger" @click="clicReset">重置密钥</el-button> -->
				</div>

				<div class="danger-left" style="margin-left: auto;">
					<div>1.API接口提交卡需要对接百越回收接口</div>
					<div>2.ApiKey和3DesKey是对接加密密钥，请妥善保管</div>
					<div>3.接口一旦接入成功，提交面值请按照真实面值提交</div>
					<div>4.在卡已经提交的情况下，充值未结束时请不要再次提交该卡</div>
					<div>5.提交卡时使用的商户订单号请不要重复</div>
				</div>
				<el-button @click="clickType" type="success" style="margin-top: 55px; margin-left: auto;">API文档</el-button>
			</div>
		</div>
	</div>

	<div class="content">
		<div class="content-assets" style="padding-bottom: 0;">
			<div class="flex assetion-width" style="width: 100%;">
				<div class="all-assets" @click="detailsClick(index)" v-for="(item,index) in listData" :key="index"
					:class="{allContent:index == detailsShow}">
					<img v-if="item.coverImg" :src="item.coverImg" style="width: 15px; height: 15px; border-radius: 20px;" />
					<div class="text">{{item.name}}</div>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<div class="content-assets">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item label="卡券名称">
					<el-input v-model="formInline.cardName" placeholder="请输入卡券名称" clearable />
				</el-form-item>
				<el-form-item label="核销编号">
					<el-input v-model="formInline.gradeCode" placeholder="请输入核销编号" clearable />
				</el-form-item>
				<el-form-item label="卡劵状态">
					<el-select v-model="formInline.status" placeholder="请选择" clearable>
						<el-option label="上架" value="10" />
						<el-option label="维护" value="20" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit">查询</el-button>
				</el-form-item>
			</el-form>

			<!-- <div style="overflow-y: auto; max-height: 160px;">
				<div class="flex" style="flex-wrap: wrap; ">
					<div class="all-waslse" @click="cardClick(item)" v-for="(item,index) in listDateObj" :key="index"
						:class="{allContent:item?.cardId==formInline.cardId}">
						<div class="text">{{item?.cardName}}</div>
						<div class="tenance" v-if="item.status==20" style="color: #fff;">维护</div>
					</div>
				</div>
			</div> -->

			<div>
				<div class="flex" style="flex-wrap: wrap;">
					<div class="flex-waslse" :class="{'flex-allContent':item?.cardId==formInline.cardId}" @click="cardClick(item)"
						v-for="(item,index) in listDateObj" :key="index">
						<div class="fold-card">{{item.maxRateRatio}}折</div>
						<div class="fold-card-right">自动</div>
						<div class="fold-card-right-top" v-if="item.status==20">维护</div>
						<div>
							<img :src="item.coverImg" class="vimage" style="width: 65px; height: 42px" />
						</div>
						<div class="voctor-detach" style="font-size: 14px" >{{item.cardName}}</div>
					</div>
				</div>
			</div>

			<div class="content-assets">
				<div class="grayStrip">
					<div class="titles-grayStrip">卡劵名称：<span style="color: #FF2D04;">{{nameCoupon}}</span></div>
					<div class="titles-grayStrip">核销编号：<span style="color: #FF2D04;">{{nameSerial}}</span></div>
				</div>
				<el-table :data="tableData" style="width: 100%">
					<!-- <el-table-column label-class-name="label-class-name" prop="gradeCode" label="核销编号" min-width="170">
					</el-table-column>
					<el-table-column prop="cardId" label="卡劵编号" min-width="100" />
					<el-table-column prop="cardName" label="卡劵名称" min-width="150" /> -->
					<el-table-column prop="categoryName" label="面值类型" min-width="150">
						<template v-slot="{ row }">
							<div v-if="row.type == 2">区间面值</div>
							<div v-else>固定面值</div>
						</template>
					</el-table-column>
					<el-table-column label="面值" min-width="150">
						<template v-slot="{ row }">
							<div v-if="row.type == 2">
								<div v-for="item in row.faceValue">{{item.min}}-{{item.max}}</div>
							</div>
							<div v-else>{{row.name}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="categoryName" label="状态" min-width="150">
						<template v-slot="{ row }">
							<div v-if="row.status==10" style="color: #67C23A;">上架</div>
							<div v-if="row.status==20" style="color: #ff3332;">维护</div>
						</template>
					</el-table-column>
					<el-table-column prop="categoryName" label="费率%" min-width="100">
						<template v-slot="{ row }">
							<div v-if="row.type == 2">
								<div v-for="item in row.faceValue">{{item.rateRatio}}%</div>
							</div>
							<div v-else>{{row.rateRatio}}%</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination v-model:current-page="formInline.pageNo" background @size-change="sizeChange"
						@current-change="currentChange" :page-sizes='[10,20,30,40,50]'
						layout="total, sizes, prev, pager, next, jumper" :total="total" />
				</div>
			</div>

		</div>
	</div>
</template>

<script setup>
	import {
		onMounted,
		reactive,
		ref
	} from 'vue';
	import {
		merchantDetails,
		merchantCardCategory,
		merchantCard,
		merchantCardDetail
	} from '@/utils/api.js';
	import dayjs from 'dayjs';

	let ids = ref(1);
	let formInline = reactive({
		pageSize: 10,
		pageNo: 1,
		cardName: null,
		gradeCode: null,
		status: null,
		cardId: '',
	})
	let nameCoupon = ref('');
	let nameSerial = ref('');
	let tableData = ref([]);
	let total = ref(0);
	let categoryId = ref('');
	let startTimeDate = ref();
	let detailsOrder = ref({});
	let detailsShow = ref(0);
	let ApiKey = ref(false);
	let information = ref({});
	let listData = ref([]);
	let listDateObj = ref([]);

	import {
		ElMessage,
	} from 'element-plus';

	function formatTime(date) {
		return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
	}

	let centerDialogVisible = ref(false);

	function details(row) {
		centerDialogVisible.value = true;
		detailsOrder.value = row;
	}

	function save() {
		centerDialogVisible.value = false;
	}

	function clickView() {
		// if (!information.value.apiKey) {
		// 	ElMessage({
		// 		message: '请先完成申请API接口',
		// 		type: 'error',
		// 	})
		// 	return;
		// }
		ApiKey.value = !ApiKey.value;
	}

	//重置密钥
	function clicReset() {}

	const copyText = async () => {
		try {
			await navigator.clipboard.writeText(information.value.apiKey);
			ElMessage({
				message: '复制成功',
				type: 'success',
			})
		} catch (err) {
			console.error('复制失败: ', err);
			alert('无法复制文本，请手动复制。');
		}
	};

	const copyText1 = async () => {
		try {
			await navigator.clipboard.writeText(information.value.descKey);
			ElMessage({
				message: '复制成功',
				type: 'success',
			})
		} catch (err) {
			console.error('复制失败: ', err);
			alert('无法复制文本，请手动复制。');
		}
	};

	function clickType() {
		downFile(
			'https://mobile.baiyuehuishou.com/api/admin-api/infra/file/24/get/f5452febec31c33eedb833dd77312ee19325dded0103ff4ab0aa073e8c4b8f78.pdf'
		)
	}

	//文件下载
	function downFile(e) {
		let fileUrl = e //服务器文件地址
		getBlob(fileUrl).then(blob => {
			saveAs(blob, '百越回收接口文档.pdf')
		})
	}

	//通过文件下载url拿到对应的blob对象
	function getBlob(url) {
		return new Promise(resolve => {
			const xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				}
			}
			xhr.send()
		})
	}
	//下载文件
	function saveAs(blob, filename) {
		var link = document.createElement('a')
		link.href = window.URL.createObjectURL(blob)
		link.download = filename
		link.click()
	}

	function infoDetails() {
		merchantDetails().then(res => {
			information.value = res.data
		})
	}

	function cardClick(item) {
		// if (formInline.cardId == item.cardId) {
		// 	formInline.cardId = '';
		// } else {
		// 	formInline.cardId = item.cardId;
		// }
		formInline.pageNo = 1;
		formInline.cardId = item?.cardId;
		nameCoupon.value = item?.cardName;
		nameSerial.value = item?.gradeCode;
		InfoCarMerch();
	}

	function infoCategory() {
		merchantCardCategory().then(res => {
			listData.value = res.data;
			listData.value.unshift({
				id: '',
				name: '全部'
			});
		})
	}

	let flos = ref(false);

	function detailsClick(index) {
		detailsShow.value = index;
		categoryId.value = listData.value[detailsShow.value].id
		merchantCardInfo();
	}

	function merchantCardInfo() {
		merchantCard({
			categoryId: categoryId.value,
			cardName: formInline.cardName || undefined,
			gradeCode: formInline.gradeCode || undefined,
			status: formInline.status || undefined,
		}).then(res => {
			listDateObj.value = res.data || [];
			if (listDateObj.value.length > 0) {
				formInline.cardId = listDateObj.value[0]?.cardId
				nameCoupon.value = listDateObj.value[0]?.cardName;
				nameSerial.value = listDateObj.value[0]?.gradeCode;
				InfoCarMerch();
			} else {
				formInline.cardId = '';
				nameCoupon.value = '';
				nameSerial.value = '';
				tableData.value = [];
				total.value = 0;
			}
		})
	}

	function onSubmit() {
		formInline.pageNo = 1;
		merchantCardInfo();
	}

	function currentChange(item) {
		formInline.pageNo = item;
		InfoCarMerch();
	}

	function sizeChange(item) {
		formInline.pageSize = item;
		InfoCarMerch();
	}

	function InfoCarMerch() {
		merchantCardDetail({
			pageSize: formInline.pageSize,
			pageNo: formInline.pageNo,
			cardId: formInline.cardId,
		}).then(res => {
			tableData.value = res.data.list;
			total.value = res.data.total;
			tableData.value.forEach((item) => {
				if (item.faceValue) {
					item.faceValue = JSON.parse(item.faceValue);
				}
			})
		})
	}

	onMounted(() => {
		infoDetails();
		infoCategory();
		merchantCardInfo();
	})
</script>

<style lang="scss" scoped>
	.content-assets {
		padding: 20px 21px;
	}

	.content {
		width: 85%;
		background-color: #fff;
		margin-left: 20px;
		margin-left: auto;
	}

	.border {
		height: 140px;
		border-left: 2px solid #0D5FF7;
	}

	.merchant {
		width: 390px;
		margin-top: 20px;
		margin-left: 10px;
		display: flex;
		align-items: center;
		white-space: nowrap;
	}

	.copy {
		font-size: 13px;
		color: #0D5FF7;
		margin-left: 10px;
	}

	.flex {
		display: flex;
	}

	.assetion-width {
		width: 100%;
		overflow: hidden;
		overflow-x: auto;
		padding-bottom: 20px;
	}

	.danger-left {
		margin-top: 20px;
		margin-left: 40px;
		color: red;
		width: 320px;
		font-size: 13px;
	}

	.all-assets {
		min-width: 120px;
		padding: 10px 0px;
		border-radius: 100px;
		background-color: #F2F2F2;
		font-size: 14px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 10px;
	}

	.all-assets:hover {
		cursor: pointer;
	}

	.text {
		margin-left: 4px;
	}

	.all-waslse {
		width: 190px;
		padding: 10px 0px;
		margin-top: 10px;
		border-radius: 100px;
		background-color: #F2F2F2;
		font-size: 14px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 10px;
		position: relative;
	}

	.all-waslse:hover {
		cursor: pointer;
		background-color: #FF535F;
		color: #fff;
	}

	.allContent {
		background-color: red;
		color: #fff;
	}

	.allContent:hover {
		background-color: red;
		color: #fff;
		scale: 1.02;
	}


	.tenance {
		font-size: 11px;
		background-color: #838383;
		padding: 3px 5px;
		border-radius: 0px 20px 0px 20px;
		position: absolute;
		right: 0px;
		top: 0;
	}

	.demo-form-inline .el-input {
		--el-input-width: 180px;
	}

	.demo-form-inline .el-select {
		--el-select-width: 180px;
	}

	.pagination {
		display: flex;
		justify-content: right;
		margin-top: 20px;
	}

	::v-deep .label-class-name .cell {
		color: red;
	}

	.grayStrip {
		background-color: #F8F8F8;
		display: flex;
		font-size: 15px;
		border-radius: 10px;
	}

	.titles-grayStrip {
		padding: 15px;
	}

	.flex-waslse {
		width: 190px;
		padding: 8px 0px;
		margin-top: 10px;
		border-radius: 7px;
		border: 1px solid #eeeeee;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		margin-left: 20px;
	}

	.flex-waslse:hover {
		cursor: pointer;
	}
	
	.flex-allContent{
		border-color: #FF535F;
		.voctor-detach{
			color: #FF535F;
		}
	}

	.voctor-detach {
		font-family: 'Microsoft YaHei', Arial, sans-serif;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-top: 6px;
		width: 135px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.fold-card {
		position: absolute;
		top: 0;
		left: 0;
		width: 47px;
		height: 17px;
		background: #ff3333;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		color: #ffffff;
		line-height: 17px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		border-radius: 5px 0px;
	}

	.fold-card-right {
		position: absolute;
		top: 3px;
		right: 10px;
		width: 10px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #ff3333;
		line-height: 17px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}

	.fold-card-right-top {
		background-color: #838383;
		color: #fff;
		padding: 3px 5px;
		border-radius: 3px 3px 5px 3px;
		position: absolute;
		bottom: 0px;
		right: 0px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 11px;
		line-height: 17px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}
</style>